import React, { useCallback, useState,useEffect } from 'react';
import { useFormContext } from './formContext';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { ENDPOINTS } from '@/config/endpoints';
import axios from 'axios';
import { useRouter } from 'next/router';
import { pushCleverTapEvent } from '../pushCleverTapEvent';

yup.addMethod(yup.string, 'restrictedEmail', function (message) {
  return this.test('restrictedEmail', message, function (value) {
    if (!value) return true; // If the value is empty, let other validations handle it

    const restrictedDomains = ['gmail.com', 'yahoo.com'];
    const domain = value.split('@')[1];

    return !restrictedDomains.includes(domain?.toLowerCase());
  });
});
const schema = () => {
  return yup.object({
    Name: yup.string().required('This field is required.'),
    Email: yup.string().required('This field is required.').email('Email is not valid').restrictedEmail('Kindly provide the official email associated with the company.'),
    Companyname: yup.string().required('This field is required.'),
  });
};


const ContactFormStep2 = ({ showPrevStep, formType,blogPostID }) => {
  const router = useRouter();

  const validationSchema = schema();
  const { state, dispatch } = useFormContext();
  const timeFrame = [
    { id: 'immediately', title:'Immediately' },
    { id: 'in 2 weeks', title: 'In 2 Weeks' },
  ]
  const [ThankyouRes, setThankyouRes] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [errMSG, setErrMSG] = useState(false);
  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    mode: "all",
    resolver: yupResolver(validationSchema)
  });
 const pillerID = ENDPOINTS.WORDPRES_DOWNLOAD_PDF;
 const matchedItem = pillerID.find((item) => item.id === blogPostID);

  const handleCaptchaSubmit = useCallback((values) => {

    if (!executeRecaptcha) {
      return false;
    }
    executeRecaptcha().then((gReCaptchaToken) => {
      onFormSubmit(values, gReCaptchaToken);
    });
  },
    [executeRecaptcha]
  );
  // handle form submit 
  async function onFormSubmit(values, gReCaptchaToken) {
    const body = {
      "formType": formType,
      "name": values.Name,
      "email": values.Email,
      "phoneNumber": state.formData.phone,
      "company": values.Companyname,
      "businessType": state.formData.exportValue,
      "turnover": state.formData.financeAmt,
      "timeLineForFinance": values.timeLineForFinance,
      "sourceUrl": window.location.href,
      "website": state.formData.website
    }

    let config = {
      method: 'post',
      url: ENDPOINTS.CONTACT_US_V1,
      headers: {
        'Content-Type': 'application/json',
        'g-recaptcha-response': gReCaptchaToken
      },
      data: body,
    };


    try {
      const response = await axios(config);
      if (response.status == 200) {
          pushCleverTapEvent("BL_Sector_Form_Submitted", { "PageName": 'Sector_Specific_Pages', ...body });
        setThankyouRes(true);
        gtag('event', 'applyLoan', {
          'event_category': 'Submit button',
          'event_label': 'Submit button'
        });
        setTimeout(() => {
          setThankyouRes(false);
            router.push('/thankyou-response')
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }, 5000);
       }
        reset();

        state.formData == {}
    } catch (err) {
      setErrMSG(true);
    }

  }

  const handlePrev = () => {
    showPrevStep(true)
    if (state.step == 2) {
      showPrevStep(true)
    }
    // Dispatch action to go back to the previous step
    dispatch({ type: 'PREV_STEP' });
  };

  return (

    <div className='bg-white'>
        <button type='button' onClick={handlePrev} className='flex items-center text-sm text-secondary font-medium mb-3'>
          <span className='mr-1'>
            <svg xmlns="https://www.w3.org/2000/svg"
              viewBox="0 0 24 24" width="24" height="24"
              fill="rgba(0,0,0,1)"><path d="M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z"></path></svg>
          </span>
          Back
        </button>
      <form onSubmit={handleSubmit(handleCaptchaSubmit)} className='relative'>
        {/* <form onSubmit={handleSubmit(onFormSubmit)} className='border border-bordercolor rounded-md p-3 min-h-[400px] relative'> */}
        
          <div className='mb-2'>
           
            <input
              type="text"
              {...register("Name")}
              name="Name"
              id="Name"
              className="w-full  rounded-lg h-[50px] text-sm sm:text-[16px] border border-[#D9D9D9] px-3 focus:outline-none"
              placeholder="Enter Your Name*"
            />
            <p className='text-progressColor4 text-xs mt-[3px]'>{errors.Name?.message}</p>
          </div>
          
         
          <div className='mb-2'>
            <input
              type="text"
              {...register("Companyname")}
              name="Companyname"
              id="Companyname"
              className="w-full  rounded-lg h-[50px] text-sm sm:text-[16px] border border-[#D9D9D9] px-3 focus:outline-none"
              placeholder="Enter your Company Name*"
            />

          <p className='text-progressColor4 text-xs mt-[3px]'>{errors.Companyname?.message}</p>
          </div>
          
          <div className='mb-2'>
            <input
              type="email"
              name="Email"
              {...register("Email")}
              id="Email"
              className="w-full rounded-lg h-[50px] text-sm sm:text-[16px] border border-[#D9D9D9] px-3 focus:outline-none"
              placeholder="Enter your Email ID*"
            />
            <p className='text-progressColor4 text-xs mt-[3px]'>{errors.Email?.message}</p>
          </div>
          
        <div className='mt-2 pl-[5px]'>
          <label className="text-xs font-medium text-secondary">When do you need finance?</label>
          <fieldset className="mt-1">
            <div className="space-x-10 flex items-center sm:flex sm:items-center sm:space-x-3 sm:space-y-0">
              {timeFrame.map((timeFrame) => (
                <div key={timeFrame.id} className="flex items-center">
                  <input
                    id={timeFrame.id}
                    name="timeLineForFinance"
                    type="radio"
                    {...register("timeLineForFinance")}
                    value={timeFrame.title}
                    defaultChecked={timeFrame.id === 'immediately'}
                    className="h-3 w-3 border-gray-300 text-indigo-600 focus:ring-bordercolor"
                  />
                  <label htmlFor={timeFrame.id} className="ml-3 block text-sm font-medium leading-6 text-gray-900">
                    {timeFrame.title}
                  </label>
                </div>
              ))}
            </div>
          </fieldset>
        </div>
        <div className='mt-2'>
          <button type='submit' className='py-1 px-3 rounded-md w-full text-white text-sm mx-auto bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-lg transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C]'>
            Submit
          </button>
        </div>
      </form>
      {errMSG ?
        <div className='text-[red] text-center' >
          <p className='text-sm font-medium mt-3'>
          There is some server response error.
          </p>
        </div>
        : null}
      {ThankyouRes ?

        <div className='text-green text-center' >
          <p className='text-sm font-medium mt-3'>
              Successfull Submission : Thank you for your interest.

          </p>
        </div>

        : null}
    </div>

  )
}

export default ContactFormStep2;